import { render, staticRenderFns } from "./top-chat-header.vue?vue&type=template&id=22711ce2&"
import script from "./top-chat-header.vue?vue&type=script&lang=js&"
export * from "./top-chat-header.vue?vue&type=script&lang=js&"
import style0 from "./top-chat-header.vue?vue&type=style&index=0&id=22711ce2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports